 import {
    Table,
    Tab,
    Header,
} from "semantic-ui-react";

const TabPublication =({datos, userState,  handleOpenModal,handleCloseModal}:any)=> {
        const TabReconocimientos = () => {
            return (

                <Table
                    columns={7}
                    compact
                    unstackable
                    fixed
                    singleLine
                    striped
                    size="small"
                    className="border-right-left-none border-bottom-none"
                >
                    <Table.Header fullWidth>
                        <Table.Row>
                            <Table.HeaderCell
                                className="background-color-FFFFFF font-size-12px"
                                width={1}
                            >
                                No.
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                className="background-color-FFFFFF font-size-12px"
                                width={3}
                            >
                                Nombre reconocimiento
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                className="background-color-FFFFFF font-size-12px"
                                width={2}
                            >
                                Institución que la otorga
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                className="background-color-FFFFFF font-size-12px"
                                width={1}
                            >
                                Año
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                className="background-color-FFFFFF font-size-12px"
                                width={1}
                            >
                                Ciudad
                            </Table.HeaderCell>
                            {userState && (
                                    <Table.HeaderCell
                                className="background-color-FFFFFF font-size-12px"
                                width={1}
                            >
                                Anexar documento
                            </Table.HeaderCell>   
                                    )}
                            
                        </Table.Row>
                    </Table.Header>
                    {datos && datos.reconocimientos ? (
                        <Table.Body style={{ height: "100%" }}>
                            {datos.reconocimientos.map((datos: any, index: number) => (
                                <Table.Row key={index}>
                                    <Table.Cell
                                        className="font-size-12px font-family-Work-Sans"
                                        width={1}
                                    >
                                        {index + 1}
                                    </Table.Cell>
                                    <Table.Cell
                                        className="font-size-12px font-family-Work-Sans"
                                        width={3}
                                    >
                                        {datos.nombre_reconocimiento}
                                    </Table.Cell>
                                    <Table.Cell
                                        className="font-size-12px font-family-Work-Sans"
                                        width={2}
                                    >
                                        {datos.institucion_otorga}
                                    </Table.Cell>
                                    <Table.Cell
                                        className="font-size-12px font-family-Work-Sans"
                                        width={1}
                                    >
                                        {datos.año}
                                    </Table.Cell>
                                    <Table.Cell
                                        width={2}
                                        className="font-size-12px font-family-Work-Sans"
                                    >
                                        {datos.ciudad}
                                    </Table.Cell>
                                    {userState && (
                                    <Table.Cell
                                        width={2}
                                        className="font-size-12px font-family-Work-Sans"
                                    >
                                        <span  onClick={()=>handleOpenModal(datos.documento)}> Ver Anexo</span>
                                    </Table.Cell>
                                    )}
                                    
                                </Table.Row>
                            ))}
                        </Table.Body>
                    ): <Header>No tiene reconocimientos</Header> }
                </Table>

            );
        };
        const TabPublicaciones = () => {
            return (

                <Table
                    columns={7}
                    compact
                    unstackable
                    fixed
                    singleLine
                    striped
                    size="small"
                    className="border-right-left-none border-bottom-none"
                >
                    <Table.Header fullWidth>
                        <Table.Row>
                            <Table.HeaderCell
                                className="background-color-FFFFFF font-size-12px"
                                width={1}
                            >
                                No.
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                className="background-color-FFFFFF font-size-12px"
                                width={3}
                            >
                                Nombre Publicaciones
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                className="background-color-FFFFFF font-size-12px"
                                width={2}
                            >
                                Tema
                            </Table.HeaderCell>
                            <Table.HeaderCell
                                className="background-color-FFFFFF font-size-12px"
                                width={1}
                            >
                                Ciudad
                            </Table.HeaderCell>

                            <Table.HeaderCell
                                className="background-color-FFFFFF font-size-12px"
                                width={1}
                            >
                                Año
                            </Table.HeaderCell>
                            {userState && (
                                    <Table.HeaderCell
                                className="background-color-FFFFFF font-size-12px"
                                width={1}
                            >
                                Anexar documento
                            </Table.HeaderCell>   
                                    )}
                            
                        </Table.Row>
                    </Table.Header>
                    {datos && datos.publicaciones ? (
                        <Table.Body style={{ height: "100%" }}>
                            {datos.publicaciones.map((datos: any, index: number) => (
                                <Table.Row key={index}>
                                    <Table.Cell
                                        className="font-size-12px font-family-Work-Sans"
                                        width={1}
                                    >
                                        {index + 1}
                                    </Table.Cell>
                                    <Table.Cell
                                        className="font-size-12px font-family-Work-Sans"
                                        width={3}
                                    >
                                        {datos.titulo_publicacion}
                                    </Table.Cell>
                                    <Table.Cell
                                        className="font-size-12px font-family-Work-Sans"
                                        width={2}
                                    >
                                        {datos.tema}
                                    </Table.Cell>
                                    <Table.Cell
                                        width={1}
                                        className="font-size-12px font-family-Work-Sans"
                                    >
                                        {datos.ciudad}
                                    </Table.Cell>
                                    <Table.Cell
                                        width={1}
                                        className="font-size-12px font-family-Work-Sans"
                                    >
                                        {datos.año}
                                    </Table.Cell>
                                    {userState && (
                                    <Table.Cell
                                        width={1}
                                        className="font-size-12px font-family-Work-Sans"
                                    >
                                        <span onClick={()=>  handleOpenModal(datos.documento)}>ver Anexo</span>
                                    </Table.Cell>
                                    )}
                                    
                                </Table.Row>
                            ))}
                        </Table.Body>
                    ) : (
                        <Header>No tiene publicaciones</Header>
                    )}
                </Table>

            );
        };
        const ReconocimientosyPublicacionesPanes = [
            {
                menuItem: "Reconomientos",
                render: () => (
                    <Tab.Pane attached={false} style={{ border: "none", height: "100%" }}>
                        <TabReconocimientos />
                    </Tab.Pane>
                ),
            },
            {
                menuItem: "Publicaciones",
                render: () => (
                    <Tab.Pane attached={false} style={{ border: "none", height: "100%" }}>
                        {" "}
                        <TabPublicaciones />
                    </Tab.Pane>
                ),
            },
        ];
        const ReconocimientosyPublicacionesTabs = () => (
            <Tab
                panes={ReconocimientosyPublicacionesPanes}
                menu={{ secondary: true, pointing: true }}
                className="tabs-jurados"
                renderActiveOnly={true}
            />
        );
        return (
            <ReconocimientosyPublicacionesTabs />
        );
    };




export default TabPublication
